export default "__VITE_ASSET__Mr4F81nU8Y3XzR5D6fP34g__"